import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import api from '../../lib/api';
import {
  LayoutDashboard, Users, GraduationCap, BookOpen, ClipboardList,
  Calendar, DollarSign, Mail, ListTodo, Shield, ChevronLeft,
  ChevronRight, X, BookMarked, FileText, UserCheck, BarChart3, Home,
  Video, Briefcase, Eye, Megaphone, Award, AlertTriangle, CheckCircle, Zap, FolderOpen, BellRing,
  UserPlus, FileStack, MessageSquare, TrendingUp, MessagesSquare, CalendarClock, Presentation,
  ArrowUpCircle, UploadCloud, Wallet
} from 'lucide-react';

const navConfig = {
  Admin: [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/admin/dashboard' },
    { label: 'Analytics', icon: TrendingUp, path: '/admin/analytics' },
    { label: 'Students', icon: GraduationCap, path: '/admin/students' },
    { label: 'Programme Managers', icon: Users, path: '/admin/programme-managers' },
    { label: 'Staff', icon: Users, path: '/admin/staff' },
    { label: 'Programmes', icon: BookMarked, path: '/admin/academics' },
    { label: 'Courses', icon: BookOpen, path: '/admin/courses' },
    { label: 'Timetable', icon: CalendarClock, path: '/admin/timetable' },
    { label: 'Finance', icon: DollarSign, path: '/admin/finance' },
    { label: 'Accounting', icon: BookMarked, path: '/admin/accounting' },
    { label: 'HR & Staff', icon: Briefcase, path: '/admin/hr' },
    { label: 'Monitoring', icon: Eye, path: '/admin/monitoring' },
    { label: 'Lessons', icon: BookOpen, path: '/admin/lessons' },
    { label: 'Assignments', icon: ClipboardList, path: '/admin/assignments' },
    { label: 'Attendance', icon: UserCheck, path: '/admin/attendance' },
    { label: 'Live Classes', icon: Video, path: '/live' },
    { label: 'Workstation', icon: FileStack, path: '/working-paper' },

    { label: 'Lectures', icon: Presentation, path: '/lectures' },
    { label: 'Mail', icon: Mail, path: '/mail' },
    { label: 'Messenger', icon: MessageSquare, path: '/messenger' },
    { label: 'Discussions', icon: MessagesSquare, path: '/discussions' },
    { label: 'Tasks', icon: ListTodo, path: '/tasks' },
    { label: 'CPD & Reviews', icon: Award, path: '/admin/cpd' },
    { label: 'Admissions', icon: UserPlus, path: '/admin/admissions' },
    { label: 'Bulk Upload', icon: UploadCloud, path: '/admin/bulk-upload' },
    { label: 'Enrolment', icon: ArrowUpCircle, path: '/admin/student-promotion' },
    { label: 'Remarks', icon: Megaphone, path: '/remarks' },
    { label: 'Audit Logs', icon: Shield, path: '/admin/audit-logs' },
    { label: 'Access Control', icon: Shield, path: '/admin/access-control' },
  ],
  SuperAdmin: [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/admin/dashboard' },
    { label: 'Analytics', icon: TrendingUp, path: '/admin/analytics' },
    { label: 'Students', icon: GraduationCap, path: '/admin/students' },
    { label: 'Programme Managers', icon: Users, path: '/admin/programme-managers' },
    { label: 'Staff', icon: Users, path: '/admin/staff' },
    { label: 'Programmes', icon: BookMarked, path: '/admin/academics' },
    { label: 'Courses', icon: BookOpen, path: '/admin/courses' },
    { label: 'Timetable', icon: CalendarClock, path: '/admin/timetable' },
    { label: 'Finance', icon: DollarSign, path: '/admin/finance' },
    { label: 'HR & Staff', icon: Briefcase, path: '/admin/hr' },
    { label: 'Accounting', icon: BookMarked, path: '/admin/accounting' },
    { label: 'Monitoring', icon: Eye, path: '/admin/monitoring' },
    { label: 'Lessons', icon: BookOpen, path: '/admin/lessons' },
    { label: 'Assignments', icon: ClipboardList, path: '/admin/assignments' },
    { label: 'Attendance', icon: UserCheck, path: '/admin/attendance' },
    { label: 'Live Classes', icon: Video, path: '/live' },
    { label: 'Workstation', icon: FileStack, path: '/working-paper' },

    { label: 'Lectures', icon: Presentation, path: '/lectures' },
    { label: 'Mail', icon: Mail, path: '/mail' },
    { label: 'Messenger', icon: MessageSquare, path: '/messenger' },
    { label: 'Discussions', icon: MessagesSquare, path: '/discussions' },
    { label: 'Tasks', icon: ListTodo, path: '/tasks' },
    { label: 'AI Test Gen', icon: Zap, path: '/admin/ai-test' },
    { label: 'CPD & Reviews', icon: Award, path: '/admin/cpd' },
    { label: 'Admissions', icon: UserPlus, path: '/admin/admissions' },
    { label: 'Bulk Upload', icon: UploadCloud, path: '/admin/bulk-upload' },
    { label: 'Enrolment', icon: ArrowUpCircle, path: '/admin/student-promotion' },
    { label: 'Announcements', icon: BellRing, path: '/admin/announcements' },
    { label: 'Remarks', icon: Megaphone, path: '/remarks' },
    { label: 'Audit Logs', icon: Shield, path: '/admin/audit-logs' },
    { label: 'Access Control', icon: Shield, path: '/admin/access-control' },
  ],
  CEO: [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/admin/dashboard' },
    { label: 'Analytics', icon: TrendingUp, path: '/admin/analytics' },
    { label: 'Lesson Approvals', icon: CheckCircle, path: '/admin/lesson-approvals' },
    { label: 'Students', icon: GraduationCap, path: '/admin/students' },
    { label: 'Programme Managers', icon: Users, path: '/admin/programme-managers' },
    { label: 'Staff', icon: Users, path: '/admin/staff' },
    { label: 'Programmes', icon: BookMarked, path: '/admin/academics' },
    { label: 'Timetable', icon: CalendarClock, path: '/admin/timetable' },
    { label: 'Finance', icon: DollarSign, path: '/admin/finance' },
    { label: 'Accounting', icon: BookMarked, path: '/admin/accounting' },
    { label: 'HR & Staff', icon: Briefcase, path: '/admin/hr' },
    { label: 'Monitoring', icon: Eye, path: '/admin/monitoring' },
    { label: 'Lessons', icon: BookOpen, path: '/admin/lessons' },
    { label: 'Assignments', icon: ClipboardList, path: '/admin/assignments' },
    { label: 'Attendance', icon: UserCheck, path: '/admin/attendance' },
    { label: 'Live Classes', icon: Video, path: '/live' },
    { label: 'Workstation', icon: FileStack, path: '/working-paper' },

    { label: 'Lectures', icon: Presentation, path: '/lectures' },
    { label: 'Mail', icon: Mail, path: '/mail' },
    { label: 'Messenger', icon: MessageSquare, path: '/messenger' },
    { label: 'Discussions', icon: MessagesSquare, path: '/discussions' },
    { label: 'Tasks', icon: ListTodo, path: '/tasks' },
    { label: 'AI Test Gen', icon: Zap, path: '/admin/ai-test' },
    { label: 'CPD & Reviews', icon: Award, path: '/admin/cpd' },
    { label: 'Admissions', icon: UserPlus, path: '/admin/admissions' },
    { label: 'Remarks', icon: Megaphone, path: '/remarks' },
    { label: 'Audit Logs', icon: Shield, path: '/admin/audit-logs' },
    { label: 'Access Control', icon: Shield, path: '/admin/access-control' },
  ],
  Founder: [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/admin/dashboard' },
    { label: 'Analytics', icon: TrendingUp, path: '/admin/analytics' },
    { label: 'Students', icon: GraduationCap, path: '/admin/students' },
    { label: 'Programme Managers', icon: Users, path: '/admin/programme-managers' },
    { label: 'Staff', icon: Users, path: '/admin/staff' },
    { label: 'Programmes', icon: BookMarked, path: '/admin/academics' },
    { label: 'Courses', icon: BookOpen, path: '/admin/courses' },
    { label: 'AI Test Gen', icon: Zap, path: '/admin/ai-test' },
    { label: 'Finance', icon: DollarSign, path: '/admin/finance' },
    { label: 'Accounting', icon: BookMarked, path: '/admin/accounting' },
    { label: 'Monitoring', icon: Eye, path: '/admin/monitoring' },
    { label: 'Remarks', icon: Megaphone, path: '/remarks' },
    { label: 'Workstation', icon: FileStack, path: '/working-paper' },

    { label: 'Lectures', icon: Presentation, path: '/lectures' },
    { label: 'Mail', icon: Mail, path: '/mail' },
    { label: 'Messenger', icon: MessageSquare, path: '/messenger' },
    { label: 'Discussions', icon: MessagesSquare, path: '/discussions' },
    { label: 'Access Control', icon: Shield, path: '/admin/access-control' },
  ],
  Principal: [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/admin/dashboard' },
    { label: 'Lesson Approvals', icon: CheckCircle, path: '/admin/lesson-approvals' },
    { label: 'Students', icon: GraduationCap, path: '/admin/students' },
    { label: 'Programme Managers', icon: Users, path: '/admin/programme-managers' },
    { label: 'Staff', icon: Users, path: '/admin/staff' },
    { label: 'Programmes', icon: BookMarked, path: '/admin/academics' },
    { label: 'AI Test Gen', icon: Zap, path: '/admin/ai-test' },
    { label: 'Monitoring', icon: Eye, path: '/admin/monitoring' },
    { label: 'Announcements', icon: BellRing, path: '/admin/announcements' },
    { label: 'Remarks', icon: Megaphone, path: '/remarks' },
    { label: 'Workstation', icon: FileStack, path: '/working-paper' },

    { label: 'Lectures', icon: Presentation, path: '/lectures' },
    { label: 'Mail', icon: Mail, path: '/mail' },
    { label: 'Messenger', icon: MessageSquare, path: '/messenger' },
    { label: 'Discussions', icon: MessagesSquare, path: '/discussions' },
    { label: 'Tasks', icon: ListTodo, path: '/tasks' },
  ],
  HeadTeacher: [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/admin/dashboard' },
    { label: 'Lesson Approvals', icon: CheckCircle, path: '/admin/lesson-approvals' },
    { label: 'Students', icon: GraduationCap, path: '/admin/students' },
    { label: 'Programmes', icon: BookMarked, path: '/admin/academics' },
    { label: 'My Cohorts', icon: Users, path: '/teacher/classes' },
    { label: 'Lessons', icon: BookOpen, path: '/teacher/lessons' },

    { label: 'Lectures', icon: Presentation, path: '/lectures' },
    { label: 'Assignments', icon: ClipboardList, path: '/teacher/assignments' },
    { label: 'Attendance', icon: UserCheck, path: '/teacher/attendance' },
    { label: 'AI Test Gen', icon: Zap, path: '/admin/ai-test' },
    { label: 'Monitoring', icon: Eye, path: '/admin/monitoring' },
    { label: 'CPD Training', icon: Award, path: '/admin/cpd' },
    { label: 'Remarks', icon: Megaphone, path: '/remarks' },
    { label: 'Workstation', icon: FileStack, path: '/working-paper' },
    { label: 'Mail', icon: Mail, path: '/mail' },
    { label: 'Messenger', icon: MessageSquare, path: '/messenger' },
    { label: 'Discussions', icon: MessagesSquare, path: '/discussions' },
    { label: 'Tasks', icon: ListTodo, path: '/tasks' },
  ],
  Teacher: [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/teacher/dashboard' },
    { label: 'My Courses', icon: Users, path: '/teacher/classes' },
    { label: 'Lessons', icon: BookOpen, path: '/teacher/lessons' },

    { label: 'Lectures', icon: Presentation, path: '/lectures' },
    { label: 'Assignments', icon: ClipboardList, path: '/teacher/assignments' },
    { label: 'AI Test Gen', icon: Zap, path: '/teacher/live-test' },
    { label: 'Attendance', icon: UserCheck, path: '/teacher/attendance' },
    { label: 'CPD Training', icon: Award, path: '/admin/cpd' },
    { label: 'My Performance', icon: Eye, path: '/teacher/monitoring' },
    { label: 'HR & Leave', icon: Briefcase, path: '/teacher/hr' },
    { label: 'Remarks', icon: Megaphone, path: '/remarks' },
    { label: 'Live Classes', icon: Video, path: '/live' },
    { label: 'Workstation', icon: FileStack, path: '/working-paper' },
    { label: 'Mail', icon: Mail, path: '/mail' },
    { label: 'Messenger', icon: MessageSquare, path: '/messenger' },
    { label: 'Discussions', icon: MessagesSquare, path: '/discussions' },
    { label: 'Tasks', icon: ListTodo, path: '/tasks' },
  ],
  Lecturer: [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/lecturer/dashboard' },
    { label: 'My Courses', icon: Users, path: '/lecturer/classes' },
    { label: 'Lessons', icon: BookOpen, path: '/lecturer/lessons' },

    { label: 'Lectures', icon: Presentation, path: '/lectures' },
    { label: 'Assignments', icon: ClipboardList, path: '/lecturer/assignments' },
    { label: 'AI Test Gen', icon: Zap, path: '/lecturer/live-test' },
    { label: 'Attendance', icon: UserCheck, path: '/lecturer/attendance' },
    { label: 'CPD Training', icon: Award, path: '/admin/cpd' },
    { label: 'My Performance', icon: Eye, path: '/lecturer/monitoring' },
    { label: 'HR & Leave', icon: Briefcase, path: '/lecturer/hr' },
    { label: 'Remarks', icon: Megaphone, path: '/remarks' },
    { label: 'Live Classes', icon: Video, path: '/live' },
    { label: 'Workstation', icon: FileStack, path: '/working-paper' },
    { label: 'Mail', icon: Mail, path: '/mail' },
    { label: 'Messenger', icon: MessageSquare, path: '/messenger' },
    { label: 'Discussions', icon: MessagesSquare, path: '/discussions' },
    { label: 'Tasks', icon: ListTodo, path: '/tasks' },
  ],
  FinanceOfficer: [
    { label: 'Finance Dashboard', icon: LayoutDashboard, path: '/admin/finance' },
    { label: 'Student Fees', icon: GraduationCap, path: '/finance/students' },
    { label: 'Accounting', icon: BookMarked, path: '/admin/accounting' },
    { label: 'Analytics', icon: TrendingUp, path: '/admin/analytics' },
    { label: 'Workstation', icon: FileStack, path: '/working-paper' },
    { label: 'Mail', icon: Mail, path: '/mail' },
    { label: 'Messenger', icon: MessageSquare, path: '/messenger' },
    { label: 'Tasks', icon: ListTodo, path: '/tasks' },
  ],
  HR_Officer: [
    { label: 'HR Dashboard', icon: Briefcase, path: '/admin/hr' },
    { label: 'Staff Documents', icon: Users, path: '/hr/staff-docs' },
    { label: 'CPD & Training', icon: Award, path: '/hr/cpd' },
    { label: 'AI Test Gen', icon: Zap, path: '/hr/ai-test' },
    { label: 'Workstation', icon: FileStack, path: '/working-paper' },

    { label: 'Mail', icon: Mail, path: '/mail' },
    { label: 'Messenger', icon: MessageSquare, path: '/messenger' },
    { label: 'Tasks', icon: ListTodo, path: '/tasks' },
  ],
  Registrar: [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/admin/dashboard' },
    { label: 'Analytics', icon: TrendingUp, path: '/admin/analytics' },
    { label: 'Students', icon: GraduationCap, path: '/admin/students' },
    { label: 'Programme Managers', icon: Users, path: '/admin/programme-managers' },
    { label: 'Staff', icon: Users, path: '/admin/staff' },
    { label: 'Programmes', icon: BookMarked, path: '/admin/academics' },
    { label: 'Courses', icon: BookOpen, path: '/admin/courses' },
    { label: 'Timetable', icon: CalendarClock, path: '/admin/timetable' },
    { label: 'Finance', icon: DollarSign, path: '/admin/finance' },
    { label: 'Accounting', icon: BookMarked, path: '/admin/accounting' },
    { label: 'Lessons', icon: BookOpen, path: '/admin/lessons' },
    { label: 'Assignments', icon: ClipboardList, path: '/admin/assignments' },
    { label: 'Attendance', icon: UserCheck, path: '/admin/attendance' },
    { label: 'Live Classes', icon: Video, path: '/live' },
    { label: 'Lectures', icon: Presentation, path: '/lectures' },
    { label: 'Admissions', icon: UserPlus, path: '/admin/admissions' },
    { label: 'Bulk Upload', icon: UploadCloud, path: '/admin/bulk-upload' },
    { label: 'Enrolment', icon: ArrowUpCircle, path: '/admin/student-promotion' },
    { label: 'HR Dashboard', icon: Briefcase, path: '/admin/hr' },
    { label: 'Staff Documents', icon: FileText, path: '/hr/staff-docs' },
    { label: 'CPD & Training', icon: Award, path: '/admin/cpd' },
    { label: 'Monitoring', icon: Eye, path: '/admin/monitoring' },
    { label: 'Announcements', icon: BellRing, path: '/admin/announcements' },
    { label: 'Remarks', icon: Megaphone, path: '/remarks' },
    { label: 'Audit Logs', icon: Shield, path: '/admin/audit-logs' },
    { label: 'Access Control', icon: Shield, path: '/admin/access-control' },
    { label: 'Workstation', icon: FileStack, path: '/working-paper' },
    { label: 'Mail', icon: Mail, path: '/mail' },
    { label: 'Messenger', icon: MessageSquare, path: '/messenger' },
    { label: 'Discussions', icon: MessagesSquare, path: '/discussions' },
    { label: 'Tasks', icon: ListTodo, path: '/tasks' },
  ],
  Student: [
    { label: 'Home', icon: Home, path: '/student/home' },
    { label: 'My Programmes', icon: BookMarked, path: '/student/programmes' },
    { label: 'Lessons', icon: BookOpen, path: '/student/lessons' },
    { label: 'Resources', icon: FolderOpen, path: '/student/resources' },
    { label: 'Assignments', icon: ClipboardList, path: '/student/assignments' },
    { label: 'Quizzes', icon: Zap, path: '/student/quizzes' },
    { label: 'Grades', icon: BarChart3, path: '/student/grades' },
    { label: 'Notifications', icon: Megaphone, path: '/student/notifications' },
    { label: 'Live Classes', icon: Video, path: '/live' },
    { label: 'Wallet', icon: Wallet, path: '/student/wallet' },
    { label: 'Mail', icon: Mail, path: '/mail' },
    { label: 'Messenger', icon: MessageSquare, path: '/messenger' },
  ],
  ProgrammeManager: [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/programme-manager/dashboard' },
    { label: 'Programmes', icon: BookMarked, path: '/programme-manager/programmes' },
    { label: 'Courses', icon: BookOpen, path: '/programme-manager/courses' },
    { label: 'Lessons', icon: FileText, path: '/programme-manager/lessons' },
    { label: 'Live Classes', icon: Video, path: '/live' },
    { label: 'Attendance', icon: UserCheck, path: '/programme-manager/attendance' },
    { label: 'Assignments', icon: ClipboardList, path: '/programme-manager/assignments' },
    { label: 'Lectures', icon: Presentation, path: '/lectures' },
    { label: 'Workstation', icon: FileStack, path: '/working-paper' },
    { label: 'Mail', icon: Mail, path: '/mail' },
    { label: 'Messenger', icon: MessageSquare, path: '/messenger' },
    { label: 'Tasks', icon: ListTodo, path: '/tasks' },
  ],
  AdmissionsOfficer: [
    { label: 'Admissions', icon: UserPlus, path: '/admin/admissions' },
    { label: 'Bulk Upload', icon: UploadCloud, path: '/admin/bulk-upload' },
    { label: 'Students', icon: GraduationCap, path: '/admin/students' },
    { label: 'Programme Managers', icon: Users, path: '/admin/programme-managers' },
    { label: 'Workstation', icon: FileStack, path: '/working-paper' },
    { label: 'Mail', icon: Mail, path: '/mail' },
    { label: 'Messenger', icon: MessageSquare, path: '/messenger' },
    { label: 'Tasks', icon: ListTodo, path: '/tasks' },
  ],
  Receptionist: [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/receptionist/dashboard' },
    { label: 'Admin Overview', icon: BarChart3, path: '/admin/dashboard' },
    { label: 'Billing & Items', icon: ClipboardList, path: '/receptionist/billing' },
    { label: 'Inventory', icon: FolderOpen, path: '/receptionist/inventory' },
    { label: 'Procurement', icon: FileText, path: '/receptionist/procurement' },
    { label: 'Messages', icon: MessageSquare, path: '/receptionist/messages' },
    { label: 'Students', icon: GraduationCap, path: '/admin/students' },
    { label: 'Programme Managers', icon: Users, path: '/admin/programme-managers' },
    { label: 'Mail', icon: Mail, path: '/mail' },
    { label: 'Messenger', icon: MessageSquare, path: '/messenger' },
    { label: 'Tasks', icon: ListTodo, path: '/tasks' },
  ],
  Nurse: [
    { label: 'Dashboard', icon: LayoutDashboard, path: '/nurse/dashboard' },
    { label: 'Admissions', icon: UserCheck, path: '/nurse/admissions' },
    { label: 'Medical Inventory', icon: FolderOpen, path: '/nurse/inventory' },
    { label: 'Emergency', icon: AlertTriangle, path: '/nurse/emergency' },
    { label: 'Mail', icon: Mail, path: '/mail' },
    { label: 'Messenger', icon: MessageSquare, path: '/messenger' },
    { label: 'Tasks', icon: ListTodo, path: '/tasks' },
  ],
};

// Section grouping map for premium sidebar
const sectionGroups = {
  'Overview': ['Dashboard', 'Analytics'],
  'People': ['Students', 'Programme Managers', 'Staff', 'Student Logins', 'Admissions', 'Bulk Upload', 'Enrolment'],
  'Academics': ['Programmes', 'Courses', 'Timetable', 'Lessons', 'Lesson Approvals', 'Lectures', 'Assignments', 'Attendance', 'Live Classes', 'AI Test Gen'],
  'Finance': ['Finance Dashboard', 'Finance', 'Accounting', 'Student Fees'],
  'HR & Operations': ['HR & Staff', 'HR Dashboard', 'Staff Documents', 'Monitoring', 'CPD & Reviews', 'CPD & Training', 'CPD Training', 'Behaviour', 'Remarks', 'Announcements'],
  'Workspace': ['Workstation', 'Tasks', 'Mail', 'Messenger', 'Discussions'],
  'System': ['Audit Logs', 'Access Control', 'Calendar', 'Knowledge Base'],
};

// Student sections
const studentSections = {
  'Home': ['Home'],
  'My Learning': ['My Programmes', 'Lessons', 'Assignments', 'Quizzes', 'Resources'],
  'Performance': ['Grades'],
  'Live & Events': ['Live Classes'],
  'Finance': ['Wallet'],
  'Communication': ['Notifications', 'Messenger', 'Mail'],
};

// Teacher sections
const teacherSections = {
  'Home': ['Dashboard'],
  'Teaching': ['My Courses', 'My Cohorts', 'Lessons', 'Lectures', 'Assignments', 'Attendance', 'Live Classes', 'AI Test Gen'],
  'HR & Development': ['CPD Training', 'CPD & Training', 'HR & Leave', 'My Performance'],
  'Management': ['Workstation', 'Tasks', 'Monitoring'],
  'Communication': ['Mail', 'Messenger', 'Discussions', 'Remarks'],
};

// Receptionist sections
const receptionistSections = {
  'Home': ['Dashboard', 'Admin Overview'],
  'Operations': ['Billing & Items', 'Inventory', 'Procurement'],
  'Communication': ['Programme Manager Messages', 'Mail', 'Messenger'],
  'Hospitality': ['Almond Guest House'],
  'People': ['Students', 'Programme Managers'],
  'Workspace': ['Tasks'],
};

// Nurse sections
const nurseSections = {
  'Home': ['Dashboard'],
  'Sick Bay': ['Admissions', 'Medical Inventory', 'Emergency'],
  'Communication': ['Mail', 'Messenger'],
  'Workspace': ['Tasks'],
};

// Programme Manager sections
const programmeManagerSections = {
  'Home': ['My Learner'],
  'Academics': ['Academics'],
  'Finance': ['Fees & Payments'],
  'Support': ['Help Desk'],
  'Communication': ['Mail', 'Messenger'],
};

function getSectionsForRole(role) {
  if (role === 'Student') return studentSections;
  if (role === 'Lecturer' || role === 'Teacher') return teacherSections;
  if (role === 'Receptionist') return receptionistSections;
  if (role === 'Nurse') return nurseSections;
  if (role === 'ProgrammeManager' || role === 'Parent') return programmeManagerSections;
  return sectionGroups;
}

export default function Sidebar({ collapsed, onToggle, onClose, role, user }) {
  const location = useLocation();
  const [messengerUnread, setMessengerUnread] = useState(0);

  useEffect(() => {
    const fetchUnread = async () => {
      try {
        const r = await api.get('/chat/unread/total');
        setMessengerUnread(r.data.total || 0);
      } catch (err) { console.error("Error:", err); }
    };
    fetchUnread();
    const interval = setInterval(fetchUnread, 10000);
    return () => clearInterval(interval);
  }, []);

  // Merge nav items from primary role + additional roles
  const primaryItems = navConfig[role] || navConfig.Student;
  const additionalRoles = user?.roles || [];
  
  let mergedItems = [...primaryItems];
  const existingPaths = new Set(primaryItems.map(i => i.path));
  
  for (const extraRole of additionalRoles) {
    const extraItems = navConfig[extraRole] || [];
    for (const item of extraItems) {
      if (!existingPaths.has(item.path)) {
        mergedItems.push(item);
        existingPaths.add(item.path);
      }
    }
  }

  // Add shared items (Calendar, Knowledge Base) for staff only (not Parents/Students)
  const isStaff = !['ProgrammeManager', 'Student'].includes(role);
  const sharedItems = isStaff ? [
    { label: 'Calendar', icon: Calendar, path: '/calendar' },
    { label: 'Knowledge Base', icon: BookOpen, path: '/knowledge-base' },
  ] : [
    { label: 'Calendar', icon: Calendar, path: '/calendar' },
  ];
  for (const item of sharedItems) {
    if (!existingPaths.has(item.path)) {
      mergedItems.push(item);
      existingPaths.add(item.path);
    }
  }
  
  const items = mergedItems;
  const sections = getSectionsForRole(role);
  
  // Build grouped items
  const groupedItems = [];
  const usedPaths = new Set();
  
  for (const [sectionName, labels] of Object.entries(sections)) {
    const sectionItems = [];
    for (const label of labels) {
      const item = items.find(i => i.label === label);
      if (item && !usedPaths.has(item.path)) {
        sectionItems.push(item);
        usedPaths.add(item.path);
      }
    }
    if (sectionItems.length > 0) {
      groupedItems.push({ section: sectionName, items: sectionItems });
    }
  }
  // Prepend ungrouped items as "Main Menu" so they appear first
  const remaining = items.filter(i => !usedPaths.has(i.path));
  if (remaining.length > 0) {
    groupedItems.unshift({ section: 'Main Menu', items: remaining });
  }

  return (
    <div
      className={`flex flex-col h-full border-r border-[#152248] ${collapsed ? 'sidebar-collapsed' : ''}`}
      style={{ background: '#1B2A5E' }}
      data-testid="sidebar"
    >
      {/* Logo */}
      <div className="flex items-center justify-between px-5 py-5 border-b border-[#243570]">
        {!collapsed && (
          <img src="/main-logo-horinzontal.png" alt="HomeUni" style={{ width: '150px', height: 'auto' }} className="object-contain" />
        )}
        {collapsed && (
          <img src="/main-logo-horinzontal.png" alt="HomeUni" className="h-8 w-auto object-contain mx-auto" />
        )}
        <button onClick={onClose} className="lg:hidden text-white/50 hover:text-white transition-colors" data-testid="sidebar-close-btn">
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Nav items grouped by section */}
      <nav className="flex-1 py-3 overflow-y-auto sidebar-nav">
        {groupedItems.map(({ section, items: sectionItems }) => (
          <div key={section} className="mb-1">
            {!collapsed && (
              <div className="px-6 pt-5 pb-2">
                <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/35">{section}</span>
              </div>
            )}
            {collapsed && <div className="pt-3" />}
            {sectionItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path ||
                (item.path !== '/mail' && item.path !== '/tasks' && location.pathname.startsWith(item.path));

              return (
                <NavLink
                  key={item.path}
                  to={item.path}
                  onClick={onClose}
                  className={`group mx-2.5 px-3 py-2 rounded-lg flex items-center gap-3 text-[13px] transition-all duration-200 ${
                    isActive
                      ? 'text-white bg-[#C9A84C]/20 border-l-2 border-[#C9A84C] font-semibold'
                      : 'text-white/60 hover:text-[#C9A84C] hover:bg-[#C9A84C]/10 border-l-2 border-transparent'
                  }`}
                  data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  <Icon className={`w-[18px] h-[18px] flex-shrink-0 transition-transform duration-200 group-hover:scale-110 ${isActive ? 'text-[#C9A84C]' : 'text-white/40 group-hover:text-[#C9A84C]'}`} />
                  {!collapsed && <span className={isActive ? 'font-medium' : 'font-normal'}>{item.label}</span>}
                  {item.label === 'Messenger' && messengerUnread > 0 && (
                    <span className="ml-auto bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
                      {messengerUnread > 99 ? '99+' : messengerUnread}
                    </span>
                  )}
                </NavLink>
              );
            })}
          </div>
        ))}
      </nav>

      {/* Collapse toggle (desktop only) */}
      <div className="hidden lg:flex px-3 py-4 border-t border-[#243570]">
        <button
          onClick={onToggle}
          className="mx-2.5 px-3 py-2 rounded-lg flex items-center gap-3 text-[13px] text-white/40 hover:text-[#C9A84C] hover:bg-[#C9A84C]/10 transition-all duration-200 w-full"
          data-testid="sidebar-toggle-btn"
        >
          {collapsed ? <ChevronRight className="w-[18px] h-[18px]" /> : <ChevronLeft className="w-[18px] h-[18px]" />}
          {!collapsed && <span>Collapse</span>}
        </button>
      </div>
    </div>
  );
}
